module.exports = __webpack_public_path__ + "scifi-selector.a5a23344e8a5afe274d3.png";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/scifi-selector.png
// module id = ../../../../../src/assets/img/scifi-selector.png
// module chunks = main